import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@/context_providers/toast_context/ToastContext';
import { StringKeys } from '@/resources/strings/StringKeys';
import { parseApiError } from '@/utils/api/parseApiError';

export function useContactMutationError() {
  const { t } = useTranslation();
  const { showErrorToast } = useToast();

  // Contact-management mutations are gated on org Respond inventory server-side; a
  // non-Respond org is already locked out at the page level, so this only fires if
  // entitlements went stale mid-session (e.g. a downgrade while the tab was open).
  const showContactMutationError = useCallback(
    async (err: unknown, fallbackKey: string) => {
      const { code } = await parseApiError(err);
      if (code === 'PLAN_RESPOND_REQUIRED') {
        showErrorToast(t(StringKeys.PLAN_RESPOND_REQUIRED_BODY));
      } else {
        showErrorToast(t(fallbackKey));
      }
    },
    [showErrorToast, t],
  );

  return showContactMutationError;
}
